import { defineStore, acceptHMRUpdate } from 'pinia';
import { createState } from './store-state.js';
import { getters } from './store-getters.js';
import { actions } from './store-actions.js';

/*
========================================================================
PINIA STORE - MAIN STORE
Luxxbox Acoustic Analyzer application state management
========================================================================
*/

export const useMainStore = defineStore('mainStore', {
    id: 'main',
    state: createState,
    getters,
    actions,
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useMainStore, import.meta.hot));
}
